<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-road
          </v-icon>
          ルート
        </h2>
      </v-col>
    </v-row>

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForm.routeName"
                        clearable
                        dense
                        hide-details="auto"
                        label="ルート名"
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.routeName = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForm.traderName"
                        clearable
                        dense
                        hide-details="auto"
                        label="運搬・処分業者名"
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.traderName = null; searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="searchForm.withoutInvisible"
                        dense
                        label="非表示を表示しない"
                        persistent-hint
                        @change="searchButtonClickEvent()"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <!-- ボタン -->
    <v-row>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          運搬ルートの追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-data-table
            :headers="tableHeaders"
            :items="transportRoutes"
            :items-per-page="-1"
            disable-sort
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.code`]="{ item }">
              <div :title="item.code" class="line-clamp one-clamp">{{ item.code }}</div>
              <div :title="item.name" class="line-clamp one-clamp">{{ item.name }}</div>
            </template>
            <template v-slot:[`item.transport_name`]="{ item }">
              <div :title="item.transport_name" class="line-clamp one-clamp">{{ item.transport_name }}</div>
            </template>
            <template v-slot:[`item.trader_name`]="{ item }">
              <div :title="item.transport_route_section.trader_name" class="line-clamp one-clamp">{{ item.transport_route_section.trader_name }}</div>
              <div :title="item.transport_route_section.trader_location_name" class="line-clamp one-clamp">{{ item.transport_route_section.trader_location_name }}</div>
            </template>
            <template v-slot:[`item.disposer_name`]="{ item }">
              <div :title="item.disposer_name" class="line-clamp one-clamp">{{ item.disposer_name }}</div>
              <div :title="item.disposer_location_name" class="line-clamp one-clamp">{{ item.disposer_location_name }}</div>
            </template>
            <template v-slot:[`item.disposal_method_name`]="{ item }">
              <div :title="item.disposal_method_name" class="line-clamp one-clamp">{{ item.disposal_method_name }}</div>
            </template>
            <template v-slot:[`item.invisible`]="{item}">
              {{ item.invisible ? '非表示' : '' }}
            </template>
            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="showButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-document-outline
                </v-icon>
                <span v-else>
                  参照
                </span>
              </v-btn>

              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>編集</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- アップグレード誘導モーダル -->
    <trial-plan-guide-dialog
      :enable-dialog="enableTrialPlanGuideDialog"
      :from-transport-route="true"
      @closeCallback="dialogCloseCallback"
    />
  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import TrialPlanGuideDialog from '../../dialogs/_TrialPlanGuideDialog'

export default {
  name: 'DriverMasterTransportRoutes',
  components: {
    CustomPagination,
    TrialPlanGuideDialog
  },
  mixins: [],
  props: {},
  data() {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      tableHeaders: [
        { value: 'code', text: 'コード\r\nルート名', width: '20%' },
        { value: 'transport_name', text: '区間１収集運搬事業者', width: '15%' },
        { value: 'trader_name', text: '区間１運搬先会社名\r\n事業場名', width: '20%' },
        { value: 'disposer_name', text: '処分業者 会社名\r\n事業場名', width: '20%' },
        { value: 'disposal_method_name', text: '処分方法', width: '10%' },
        { value: 'invisible', text: '非表示', width: '5%' },
        { value: 'editable', text: '詳細・編集', align: 'end', width: '10%' },
      ],
      transportRoutes : [],
      enableTrialPlanGuideDialog: false,
      searchForm: {
        routeName: null,
        traderName: null,
        withoutInvisible: true,
      },
    }
  },
  computed: {
    ...mapState('DriverMasterTransportRoute', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapState('DriverTenantConfiguration', {
      isTrialPlan: 'use_trial_plan',
    }),
  },
  watch: {},
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForm.routeName = this.searchCondition.route_name
    this.searchForm.traderName = this.searchCondition.trader_name
    this.searchForm.withoutInvisible = this.searchCondition.without_invisible
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit;
    this.searchTransportRoutes()
  },
  methods: {
    ...mapActions('DriverMasterTransportRoute', {
      fetchTransportRoutes: 'index',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
      checkCount: 'check',
    }),
    searchButtonClickEvent () {
      this.page = 1
      this.searchTransportRoutes()
    },
    addButtonClickEvent () {
      if (this.isTrialPlan) {
        let params = { without_invisible: true}
        this.checkCount(params).then((content) => {
          if (content.pagination.total_count < 10) {
            this.$router.push({name: 'DriverMasterTransportRouteNew'})
          } else {
            this.enableTrialPlanGuideDialog = true
          }
        })
      } else {
        this.$router.push({name: 'DriverMasterTransportRouteNew'})
      }
    },
    showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterTransportRoute', params: { id: item.id }})
    },
     editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterTransportRouteEdit', params: { id: item.id }})
    },
    changePage(page) {
      this.page = page;
      this.searchTransportRoutes()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchTransportRoutes()
    },
    searchTransportRoutes () {
      const params = {
        route_name: this.searchForm.routeName,
        trader_name: this.searchForm.traderName,
        without_invisible: this.searchForm.withoutInvisible,
        page: this.page,
        limit: this.perPage
      }
      /**
       * @typedef content { Object }
       * @property transport_routes { List }
       */
      this.fetchTransportRoutes(params).then((content) => {
        this.transportRoutes = content.transport_routes
      })
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
     dialogCloseCallback() {
      this.enableTrialPlanGuideDialog = false;
    },
  }
}
</script>

<style scoped>

</style>
